import type { SearchTarget } from '../types';

// Objet de recherche du profil : clé persistée (search_target) → libellé affiché.
// Le libellé inclut l'article pour gérer l'élision : « À la recherche d'» + « un stage ».
export const SEARCH_TARGETS: { value: SearchTarget; label: string }[] = [
  { value: 'stage', label: 'un stage' },
  { value: 'alternance', label: 'une alternance' },
  { value: 'contrat', label: 'un contrat' },
];

export const DEFAULT_SEARCH_TARGET: SearchTarget = 'alternance';

const PREFIX = 'À la recherche d’';

export function searchTargetLabel(target: SearchTarget | null | undefined): string {
  const found = SEARCH_TARGETS.find((o) => o.value === target);
  const fallback = SEARCH_TARGETS.find((o) => o.value === DEFAULT_SEARCH_TARGET)!;
  return (found ?? fallback).label;
}

// Phrase complète affichée sous le nom (défaut « une alternance » si non renseigné).
export function searchStatut(target: SearchTarget | null | undefined): string {
  return `${PREFIX}${searchTargetLabel(target)}`;
}
